import { HospModel } from './../../models/hospital.model';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-selected-hospital',
  templateUrl: './selected-hospital.component.html',
  styleUrls: ['./selected-hospital.component.scss']
})
export class SelectedHospitalComponent implements OnInit {

  @Input('isVisible') isVisible: boolean;
  @Input('hospList') hospList: HospModel[];
  @Output() setHosp = new EventEmitter();
  @Output() close = new EventEmitter();

  // hospList: HospModel[] = [];
  selectedValue: HospModel[] = [];
  disabledButton: boolean = true;

  constructor() {
    // this.hospList.push(
    //   { hospCode: "B001", hospName: "โรงพยาบาลกรุงเทพ" },
    //   { hospCode: "B002", hospName: "โรงพยาบาลกรุงเทพคริสเตียน" },
    //   { hospCode: "B008", hospName: "โรงพยาบาลเกษมราษฎร์ (ประชาชื่น)" },
    //   { hospCode: "2411", hospName: "โรงพยาบาลนนทเวช" },
    //   { hospCode: "0213", hospName: "โรงพยาบาลกระบี่นครินทร์" }
    // );
  }

  ngOnInit() {

  }

  checkValue(): void {
    if (this.selectedValue) {
      this.disabledButton = false;
    } else {
      this.disabledButton = true;
    }
  }

  setData(): void {
    if (this.selectedValue) {
      this.setHosp.emit(this.selectedValue);
    }
  }

  logout(): void {
    this.close.emit();
  }

}


